<template>
  <section>
    <h3 class="primary--text">
      <template v-if="eventDateObj.params !== null">
          <span v-if="normalisedActivity === 'document.moved'">
            <a @click="viewFile(eventDateObj)" class="no-link-style" style="font-weight:500" >
              {{ eventDateObj.params.filename }}
            </a> was moved from
          </span>
          <span v-if="normalisedActivity === 'document.copied'">
            <a @click="viewFile(eventDateObj)" class="no-link-style" style="font-weight:500" >
              {{ eventDateObj.params.filename }}
            </a> was copied from
          </span>
          <a @click="viewFile(eventDateObj)" class="no-link-style" style="font-weight:500" >
            {{ getParam(eventDateObj).old }}
          </a>
      </template>
      {{ text }}
      <span style="font-weight:500">
        <a @click="viewFile(eventDateObj)" class="no-link-style" style="font-weight:500" >
          {{ getParam(eventDateObj).new }}
        </a>
      </span>
    </h3>
  </section>
</template>

<script>
import { normaliseEventType } from "@/stores/timeline/eventTypes"
import { mapState } from 'vuex'

export default {
  name: "DocumentActivity",
  data: () => ({}),
  props: ["eventDateObj", "text", "accountId"],
  computed: {
    normalisedActivity() {
      return normaliseEventType(this.eventDateObj && this.eventDateObj.activity)
    }
  },
  components: {
    ...mapState({
      activity: state => state.timeline.event_types
    })
  },
  methods: {
    async viewFile(event) {
      if (!this.viewing) {
        this.viewing = true
        const url = window.location.href.startsWith("http://localhost") ? `http://localhost:6543${event.params.url}` : event.params.url
        const auth = 'Bearer ' + window.localStorage.session

        const anchor = document.createElement("a")
        document.body.appendChild(anchor)
        const headers = new Headers()
        headers.append("Authorization", auth)

        const response = await fetch(url, { headers })
        const blobby = await response.blob()
        const objectUrl = window.URL.createObjectURL(blobby)
        anchor.href = objectUrl
        anchor.target = "blank"
        anchor.click()
        this.viewing = false
      }
    },
    getParam(e) {
      const activity = normaliseEventType(e.activity)
      if (activity === "document.copied" || activity === "document.moved") {
        return { old: e.params.eventParams.oldPath, new: e.params.eventParams.newPath }
      } else {
        return { old: e.params.eventParams.oldName, new: e.params.eventParams.newName }
      }
    }
  }
}
</script>
